module.exports = __webpack_public_path__ + "img/zm.2ab866dd.svg";